





























































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import SepaMandateJson from "../../shared/SepaMandateJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateSepaMandate } from "../../shared/SepaMandateJson";

export default Vue.extend({
  name: "FormSepaMandate",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Object,
    showAddressInputs: Boolean,
    editable: Boolean,
    submitValidation: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      details: null as SepaMandateJson | null,
      selectedRentalConditionTemplate: null as number | null,
      toValidate: {} as any,
      validation: null as ValidationResult<SepaMandateJson> | null,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.details = this.data;

      if (this.submitValidation && this.details != null) {
        this.validation = validateSepaMandate(this.details);
      }
    },

    //START set cached data

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateSepaMandate(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    submitValidation: function () {
      if (this.submitValidation) {
        if (this.details != null) {
          this.validation = validateSepaMandate(this.details);
        }
      }
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.details != null) {
          return this.details.IBAN.toUpperCase()
            .replace(/[^0-9A-Z]/g, "")
            .replace(/(.{1,4})/g, "$1 ")
            .trim();
        }
      },
      set(value: string) {
        if (this.details != null) {
          this.details.IBAN = value;
        }
      },
    },
  },
});
